import { useState } from 'react'
import { Mail } from 'lucide-react'
import api from '../../services/api'

// OSPROD-MAIL-CAL-L3 / fix: a hard <a href> navigation to
// /api/mail/accounts/google/start arrived without the JWT (token lives
// in localStorage, not a cookie) and got rejected with Unauthorized.
// Now we fetch the start route via axios — auth header attached by
// the request interceptor — and the route returns the Google consent
// URL as JSON so the browser can navigate there in one go. The rest
// of the flow is unchanged: Google → Python's callback → page redirect
// back here with ?connected=ok.

interface Props {
  module: 'mail' | 'calendar'
}

export default function ConnectGoogleButton({ module }: Props) {
  const [pending, setPending] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const onClick = async () => {
    setError(null)
    setPending(true)
    try {
      // Mail + Calendar both use native @os/{module} OAuth wrappers
      // mounted at /api/{module}/google/connect. Both return {url};
      // legacy shims (CalDAV / IMAP) return {authUrl}. Pass returnTo so
      // the wrapper round-trips us back to /workspace/<module> instead
      // of the default '/'.
      const isNative = module === 'mail' || module === 'calendar'
      const path = isNative
        ? `/${module}/google/connect`
        : `/${module}/accounts/google/start`
      const returnTo = `/workspace/${module}?connected=ok`
      const { data } = await api.get<{ url?: string; authUrl?: string }>(
        path,
        isNative ? { params: { returnTo } } : undefined,
      )
      const target = data?.url ?? data?.authUrl
      if (target) {
        window.location.href = target
        return
      }
      setError('Не удалось получить ссылку Google.')
    } catch (err: any) {
      const detail = err?.response?.data?.error || err?.message || 'Не удалось подключиться'
      setError(String(detail))
    } finally {
      setPending(false)
    }
  }

  return (
    <div className="inline-flex flex-col gap-1">
      <button
        type="button"
        onClick={onClick}
        disabled={pending}
        className="inline-flex items-center gap-2 rounded-md bg-discord-blurple px-4 py-2 text-sm font-medium text-white hover:bg-discord-blurple/90 transition disabled:opacity-60 disabled:cursor-progress"
      >
        <Mail size={16} />
        {pending ? 'Подключаем…' : 'Connect Google'}
      </button>
      {error && (
        <span className="text-xs text-red-400 max-w-xs">{error}</span>
      )}
    </div>
  )
}
